<i18n>
{
  "en": {
    "explore-a-demo-shop": "Explore a demo shop",
    "livepaow-is-title": "Livepaow is the center for managing your shop",
    "livepaow-feature-share" : "The shops in livepaow have a common relationship similar to shops in a mall. You can set up the dissemination of stores information, product lists, various promotions. For customer to access"
  },
  "th": {
    "explore-a-demo-shop": "สำรวจร้านค้าสาธิต",
    "livepaow-is-title": "Livepaow เป็นศูนย์รวมสำหรับจัดการร้านค้าของคุณ",
    "livepaow-feature-share" : "ร้านค้าใน livepaow มีความสัมพันธ์ร่วมกันคล้ายร้านค้าในห้างสรรพสินค้า คุณสามารถตั้งค่าการเผยแพร่ข้อมูลของร้านค้า รายการสินค้า โปรโมชั่นต่างๆ เพื่อให้ลูกค้าเข้าถึงได้"
  }
}
</i18n>
<template>
  <div>
    <v-container
      fluid
    >
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          cols="12"
          sm="10"
          md="12"
          lg="7"
          xl="7"
        >
          <v-row
            align="center"
            justify="center"
            class="mb-12"
          >
            <v-col
              class="ma-5"
              cols="12"
              md="3"
              lg="3"
              xl="3"
            >
              <v-card
                outlined
              >
                <v-card-text>
                  <div class="title mb-2 black--text">
                    {{ $t('explore-a-demo-shop') }}
                  </div>
                </v-card-text>
                <v-card-actions class="white">
                  <v-row
                    align="center"
                    justify="center"
                  >
                    <v-col
                      cols="10"
                    >
                      <v-icon>fab fa-facebook-square</v-icon>
                    </v-col>
                  </v-row>
                </v-card-actions>

              </v-card>
            </v-col>

            <v-col
              class="ma-5"
              cols="12"
              md="3"
              lg="7"
              xl="7"
            >
              <v-card
                outlined
              >
                <v-card-text>
                  <div class="title mb-2 black--text">
                    {{ $t('livepaow-is-title') }}
                  </div>
                  <div class="body-1">
                    {{$t('livepaow-feature-share')}}
                  </div>
                </v-card-text>
              </v-card>
            </v-col>

          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'TheCShopContentSecond'
}
</script>

<style>

</style>
